export default class Player {
  constructor({
    age = null,
    countryCode = null,
    name = null,
    pictureUrl = null,
    position = null,
    slug = null,
    uuid = null,
    club = null,
    nationalTeam = null,
  } = {}) {
    this.age = age;
    this.countryCode = countryCode;
    this.name = name;
    this.pictureUrl = pictureUrl;
    this.position = position;
    this.slug = slug;
    this.uuid = uuid;
    this.club = club;
    this.nationalTeam = nationalTeam;
  }

  static createFromObject(data) {
    return new Player(data);
  }

  static createCollectionFromObject(data) {
    return data.map(
      (playerData) => Player.createFromObject(playerData),
    );
  }
}
